import React, { FC } from 'react';
import { useNavigate } from 'react-router';
import CustomModal from '../../../common-components/CustomModal';
import { ReactComponent as BigWarningCross } from '../../../layout/icons/white-cross-in-red-circle-big.svg';
import { ReactComponent as WarningCross } from '../../../layout/icons/white-cross-in-red-circle.svg';
import RouteUrlPaths from '../../../RouteUrlPaths';
import CMSStore from '../../../stores/content-stores/CMSStore';

interface WithdrawCreditBeforeAccountCloseProps {
  cmsStore: CMSStore;
}

const WithdrawCreditBeforeAccountClose: FC<WithdrawCreditBeforeAccountCloseProps> = (props) => {
  const { cmsStore } = props;
  const { modalStore } = cmsStore.rootStore;
  const navigate = useNavigate();
  const headerText = cmsStore.getContent('WithdrawCreditBeforeAccountClose')?.content;
  const contentText = cmsStore.getContent('WithdrawCreditBeforeAccountClose')?.subText;
  const primaryButtonText = cmsStore.getContent('SeeAndWithdrawCreditButton')?.content;

  const onPrimaryButtonClick = () => {
    modalStore.closeModal();
    navigate(RouteUrlPaths.TransactionAndUsage);
  };

  return (
    <CustomModal
      topIconDesktop={<WarningCross />}
      topIconMobile={<BigWarningCross />}
      header={headerText}
      contentText={contentText}
      primaryButtonText={primaryButtonText}
      closable
      isHeaderRed
      onPrimaryButtonClick={onPrimaryButtonClick}
    />
  );
};

export default WithdrawCreditBeforeAccountClose;
